import styled from 'styled-components';

const ItemWrapper = styled.span`
  position: relative;
  display: inline-block;
`;

const TooltipBubble = styled.span`
  position: absolute;
  bottom: 180%;
  left: 1%;
  transform: translateX(-50%);
  background-color: ${(props) => props.theme.colors.widget_background};
  color: ${(props) => props.theme.colors.text};
  border: 1px solid ${(props) => props.theme.colors.outline};
  box-shadow: ${(props) => props.theme.shadows.dropdown};
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 9999;
  pointer-events: none;
`;

export default { ItemWrapper, TooltipBubble };
